import { Component, ViewChild, OnInit } from '@angular/core'

import { jqxTreeGridComponent } from 'jqwidgets-ng/jqxtreegrid'

import { OrgModel } from '../../models/org-model'
import { GetAllOrgGateway } from '../../gateways/get-allorg-gateways'

@Component({
    templateUrl: `jq-treegrid.component.html`
})
export class JQTreeGrid implements OnInit {
    @ViewChild('TreeGrid', { static: true }) treeGrid: jqxTreeGridComponent
    jqx: any
    viewModel: OrgModel[]
    org: any = []

    source: any = {
        dataFields: [
            { name: 'OrgID', type: 'number' },
            { name: 'ParentOrgId', type: 'number' },
            { name: 'OrgShortName', type: 'string' },
            { name: 'OrgName', type: 'string' },
            { name: 'EffectiveDate', type: 'date' },
            { name: 'TerminationDate', type: 'date' },
            { name: 'OrgType', type: 'string' }
        ],
        hierarchy: {
            keyDataField: { name: 'OrgID' },
            parentDataField: { name: 'ParentOrgId' }
        },
        dataType: 'json',
        id: 'OrgID',
        localData: this.org
    }
    dataAdapter = new jqx.dataAdapter(this.source)

    columns = [
        { text: 'OrgID', dataField: 'OrgID', width: 200 },
        { text: 'OrgShortName', dataField: 'OrgShortName', width: 160 },
        { text: 'OrgName', dataField: 'OrgName', width: 120 },
        { text: 'EffectiveDate', dataField: 'OrgEffectiveDate', cellsFormat: 'd', width: 120 },
        { text: 'TerminationDate', dataField: 'OrgTerminationDate', width: 250 },
        { text: 'OrgType', dataField: 'OrgType', width: 120 }
    ]

    ready(): void {
        this.treeGrid.expandRow(2)
    }

    excelExportClick(): void {
        console.log('export call: ')
        this.treeGrid.exportData('xls')
    }

    htmlExportClick(): void {
        this.treeGrid.exportData('html')
    }

    jsonExportClick(): void {
        this.treeGrid.exportData('json')
        console.log(this.treeGrid.exportData('json'))
    }
    constructor(private getallorggateway: GetAllOrgGateway) {}

    ngOnInit(): void {
        this.getdata()
    }

    public getdata() {
        this.getallorggateway.getOrgDetail().subscribe((model: OrgModel[]) => {
            this.viewModel = model
            this.org = this.viewModel
            this.source.localdata = this.org
            this.dataAdapter.dataBind()
            this.treeGrid.updateBoundData()
        })
    }
}
